import { ILocationItemResponse } from "../../services/edit-hospital-location/edit-hospital-location.interface";

export const actionTypes = {
  SET_LOCATION_SELECTED: "SET_LOCATION_SELECTED",
};

const setLocationSelected = (payload: ILocationItemResponse[]) => ({
  type: actionTypes.SET_LOCATION_SELECTED,
  payload,
});

export default {
  setLocationSelected,
};
